import React, { useState, useEffect } from 'react';
import {
  Heart,
  Calendar,
  Map,
  Music,
  Camera,
  Menu,
  X,
  Clock,
  Gift,
  Hotel,
  Plane,
  ChevronLeft,
  ChevronRight,
  Wine,
  Coffee,
} from 'lucide-react';

const ModernVows = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeTimeline, setActiveTimeline] = useState(0);

  const imageUrls = [
    'https://images.unsplash.com/photo-1646325311277-0c35409fdd57?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1507124064746-6cb17f4774d9?q=80&w=1987&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1666041835571-bd78d56d9646?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1666041839521-0fb8ce16b1fa?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1588010002699-547a7ec4fdfa?q=80&w=3088&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1508366376044-ce8f01e223cf?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  ];

  const carouselItems = [
    {
      title: 'The Proposal',
      description: 'Where it all began...',
      image:
        'https://images.unsplash.com/photo-1684170553863-cfc4cc448083?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Engagement Party',
      description: 'Celebrating with loved ones...',
      image:
        'https://images.unsplash.com/photo-1684170553010-a993305bafb1?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
    {
      title: 'Pre-Wedding',
      description: 'Getting ready for the big day...',
      image:
        'https://images.unsplash.com/photo-1695719755889-5cea5fd5f55e?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    },
  ];

  const timelineEvents = [
    { time: '2:00 PM', event: 'Wedding Ceremony', icon: Heart },
    { time: '3:30 PM', event: 'Cocktail Hour', icon: Wine },
    { time: '5:00 PM', event: 'Reception Dinner', icon: Coffee },
    { time: '7:00 PM', event: 'First Dance', icon: Music },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 5000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearInterval(timer);
    };
  }, []);

  const NavLink = ({ href, children }) => (
    <a
      href={href}
      className="px-4 py-2 text-blue-800 transition-colors duration-300 hover:text-blue-600"
    >
      {children}
    </a>
  );

  return (
    <div className="nunito min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Navbar */}
      <nav
        className={`fixed z-50 w-full transition-all duration-300 ${
          scrolled ? 'bg-white py-2 shadow-md' : 'bg-transparent py-4'
        }`}
      >
        <div className="container mx-auto flex items-center justify-between px-4">
          <a href="#" className="text-3xl text-blue-800">
            J & M
          </a>

          <button
            className="text-blue-800 lg:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className="hidden items-center space-x-8 lg:flex">
            <NavLink href="#story">Our Story</NavLink>
            <NavLink href="#details">Details</NavLink>
            <NavLink href="#gallery">Gallery</NavLink>
            <NavLink href="#rsvp">RSVP</NavLink>
          </div>
        </div>

        <div
          className={`absolute w-full bg-white shadow-lg transition-all duration-300 lg:hidden ${
            isMenuOpen
              ? 'max-h-64 opacity-100'
              : 'max-h-0 overflow-hidden opacity-0'
          }`}
        >
          <div className="flex flex-col items-center py-4">
            <NavLink href="#story">Our Story</NavLink>
            <NavLink href="#details">Details</NavLink>
            <NavLink href="#gallery">Gallery</NavLink>
            <NavLink href="#rsvp">RSVP</NavLink>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 pt-20 text-center">
        <div className="absolute inset-0 opacity-70">
          <div
            className="absolute inset-0 scale-110 transform bg-[url('https://images.unsplash.com/photo-1710317903755-3893382a25c7?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')] bg-cover bg-center"
            style={{
              transform: `translateY(${scrolled ? '10%' : '0%'})`,
              transition: 'transform 0.5s ease-out',
            }}
          />
        </div>
        <div className="animate-fade-in relative z-10">
          <h1 className="mb-6 text-5xl text-blue-800 md:text-7xl">
            Jessica & Michael
          </h1>
          <p className="mb-8 text-xl text-blue-600 md:text-2xl">
            Are getting married
          </p>
          <div className="flex items-center justify-center space-x-2 text-blue-800">
            <Calendar className="animate-bounce" />
            <span className="text-2xl">08.15.2025</span>
          </div>
        </div>
      </section>

      {/* Countdown Section */}
      <section className="bg-blue-100 py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-8">
            {['Days', 'Hours', 'Minutes', 'Seconds'].map((unit, index) => (
              <div key={unit} className="text-center">
                <div className="mb-2 flex h-24 w-24 items-center justify-center rounded-lg bg-white shadow-lg">
                  <span className="text-3xl font-bold text-blue-800">
                    {99 - index * 20}
                  </span>
                </div>
                <span className="text-blue-600">{unit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section id="story" className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">
            Our Love Story
          </h2>
          <div className="mx-auto max-w-4xl">
            <div className="relative">
              <div className="absolute left-1/2 h-full w-0.5 -translate-x-1/2 transform bg-blue-200" />

              {[
                { year: '2022', event: 'First Meet', side: 'left' },
                { year: '2023', event: 'First Date', side: 'right' },
                { year: '2024', event: 'Proposal', side: 'left' },
                { year: '2025', event: 'Wedding', side: 'right' },
              ].map((item, index) => (
                <div
                  key={item.year}
                  className={`mb-8 flex items-center ${
                    item.side === 'left' ? 'flex-row-reverse' : ''
                  }`}
                >
                  <div className="w-1/2 px-4">
                    <div
                      className={`transform rounded-lg bg-blue-50 p-6 shadow-lg transition-all duration-500 hover:scale-105 ${
                        item.side === 'left' ? 'mr-4' : 'ml-4'
                      }`}
                    >
                      <h3 className="mb-2 text-xl text-blue-800">
                        {item.year}
                      </h3>
                      <p className="text-blue-600">{item.event}</p>
                    </div>
                  </div>
                  <div className="z-10 h-4 w-4 transform rounded-full bg-blue-500 transition-all duration-500 hover:scale-150" />
                  <div className="w-1/2" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Carousel */}
      <section className="bg-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">
            Our Journey
          </h2>
          <div className="relative mx-auto max-w-4xl">
            <div className="overflow-hidden rounded-lg shadow-xl">
              <div className="relative h-96">
                {carouselItems.map((item, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 transition-opacity duration-500 ${
                      currentSlide === index ? 'opacity-100' : 'opacity-0'
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                      <h3 className="mb-2 text-2xl text-white">{item.title}</h3>
                      <p className="text-white/80">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button
              onClick={() =>
                setCurrentSlide(
                  (prev) =>
                    (prev - 1 + carouselItems.length) % carouselItems.length
                )
              }
              className="absolute left-4 top-1/2 -translate-y-1/2 transform rounded-full bg-white/80 p-2 shadow-lg transition-colors duration-300 hover:bg-white"
            >
              <ChevronLeft className="text-blue-800" />
            </button>
            <button
              onClick={() =>
                setCurrentSlide((prev) => (prev + 1) % carouselItems.length)
              }
              className="absolute right-4 top-1/2 -translate-y-1/2 transform rounded-full bg-white/80 p-2 shadow-lg transition-colors duration-300 hover:bg-white"
            >
              <ChevronRight className="text-blue-800" />
            </button>
          </div>
        </div>
      </section>

      {/* Wedding Timeline */}
      <section id="details" className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">
            Wedding Day Timeline
          </h2>
          <div className="mx-auto max-w-3xl">
            {timelineEvents.map((event, index) => (
              <div
                key={index}
                className="group relative pb-8 pl-8"
                onMouseEnter={() => setActiveTimeline(index)}
              >
                <div className="absolute left-0 top-0 h-full w-0.5 bg-blue-200 group-last:h-6" />
                <div
                  className={`absolute left-0 top-0 h-full w-0.5 origin-top bg-blue-600 transition-transform duration-500 ${
                    index <= activeTimeline ? 'scale-y-100' : 'scale-y-0'
                  }`}
                />
                <div className="absolute left-[-8px] top-0 h-4 w-4 rounded-full bg-blue-200 transition-colors duration-300 group-hover:bg-blue-600" />
                <div className="ml-6">
                  <event.icon className="mr-2 inline-block text-blue-600" />
                  <time className="text-sm font-medium text-blue-600">
                    {event.time}
                  </time>
                  <h3 className="mt-1 text-lg text-blue-800">{event.event}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Photo Gallery Grid */}
      <section id="gallery" className="bg-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">
            Photo Gallery
          </h2>
          <div className="mx-auto grid max-w-6xl grid-cols-2 gap-4 md:grid-cols-3">
            {imageUrls.map((url, index) => (
              <div
                key={index}
                className="aspect-square overflow-hidden rounded-lg transition-transform duration-300 hover:scale-105 hover:transform"
              >
                <img
                  src={url}
                  alt={`Gallery image ${index + 1}`}
                  className="h-full w-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Travel & Accommodation */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">
            Travel & Stay
          </h2>
          <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-3">
            <div className="transform rounded-lg bg-white p-6 shadow-lg transition-all duration-500 hover:scale-105">
              <Plane className="mb-4 text-blue-600" />
              <h3 className="mb-2 text-xl text-blue-800">Getting Here</h3>
              <p className="text-blue-600">
                Seattle-Tacoma International Airport (20 mins)
              </p>
            </div>
            <div className="transform rounded-lg bg-white p-6 shadow-lg transition-all duration-500 hover:scale-105">
              <Hotel className="mb-4 text-blue-600" />
              <h3 className="mb-2 text-xl text-blue-800">Accommodation</h3>
              <p className="text-blue-600">
                Special rates at Grand Hotel Seattle
              </p>
            </div>
            <div className="transform rounded-lg bg-white p-6 shadow-lg transition-all duration-500 hover:scale-105">
              <Map className="mb-4 text-blue-600" />
              <h3 className="mb-2 text-xl text-blue-800">Local Area</h3>
              <p className="text-blue-600">
                Explore Seattle's finest attractions
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* RSVP Form */}
      <section id="rsvp" className="bg-blue-50 py-20">
        <div className="container mx-auto px-4">
          <h2 className="mb-12 text-center text-4xl text-blue-800">RSVP</h2>
          <form className="mx-auto max-w-md space-y-6">
            <div>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full rounded-lg border border-blue-200 px-4 py-2 transition-all duration-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>
            <div>
              <input
                type="email"
                placeholder="Email Address"
                className="w-full rounded-lg border border-blue-200 px-4 py-2 transition-all duration-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>
            <div>
              <textarea
                placeholder="Special Requests or Notes"
                rows={4}
                className="w-full rounded-lg border border-blue-200 px-4 py-2 transition-all duration-300 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
            </div>
            <div className="flex items-center space-x-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="attendance"
                  className="form-radio text-blue-600"
                />
                <span className="text-blue-800">Happily Attending</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="attendance"
                  className="form-radio text-blue-600"
                />
                <span className="text-blue-800">Regretfully Declining</span>
              </label>
            </div>
            <button
              type="submit"
              className="w-full transform rounded-lg bg-blue-600 py-3 text-white transition-all duration-300 hover:scale-105 hover:bg-blue-700"
            >
              Send RSVP
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-blue-800 py-12 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="mb-6 text-3xl">Jessica & Michael</h2>
            <p className="mb-8">August 15, 2025 • Seattle, Washington</p>
            <div className="mb-8 flex items-center justify-center space-x-6">
              {[Clock, Map, Calendar, Heart].map((Icon, index) => (
                <Icon
                  key={index}
                  size={24}
                  className="transform cursor-pointer transition-transform duration-300 hover:scale-125"
                />
              ))}
            </div>
            <p className="text-blue-200">
              Made with{' '}
              <Heart
                className="inline-block animate-pulse text-pink-400"
                size={16}
              />{' '}
              for our special day by Tailwine Studio
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ModernVows;
